import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setDataLayout,
  setDataTheme,
} from "../../data/redux/themeSettingSlice";
import {
  setExpandMenu,
  setMobileSidebar,
  toggleMiniSidebar,
} from "../../data/redux/sidebarSlice";
import { all_routes } from "../../../feature-module/router/all_routes";
import { RootState } from "../../../redux/reducers";
// import { academicYear } from "../selectoption/selectoption";
import { useState } from "react";
import {
  SET_SELECTED_BRANCH,
} from "../../../redux/actions/types";
import { Input, Select } from "antd";

const Header = () => {
  const routes = all_routes;
  const dispatch = useDispatch();
  const dataTheme = useSelector((state: any) => state.themeSetting.dataTheme);
  const dataLayout = useSelector((state: any) => state.themeSetting.dataLayout);
  const [notificationVisible, setNotificationVisible] = useState(false);

  const {
    user,
    school,
    school_locations = [],
    selected_branch,
  } = useSelector((state: RootState) => state.auth);
  const mobileSidebar = useSelector(
    (state: any) => state.sidebarSlice.mobileSidebar
  );

  const location = useLocation();
  const isSuperAdminDashboard =
    location.pathname === routes.superAdminDashboard;
  const isSchoolSetup = location.pathname === routes.schoolSetup;
  const isSchoolList = location.pathname === routes.schoolList;

  const toggleMobileSidebar = () => {
    dispatch(setMobileSidebar(!mobileSidebar));
  };

  const onMouseEnter = () => {
    dispatch(setExpandMenu(true));
  };
  const onMouseLeave = () => {
    dispatch(setExpandMenu(false));
  };
  const handleToggleMiniSidebar = () => {
    if (dataLayout === "mini_layout") {
      dispatch(setDataLayout("default_layout"));
      localStorage.setItem("dataLayout", "default_layout");
    } else {
      dispatch(toggleMiniSidebar());
    }
  };

  const handleToggleClick = () => {
    if (dataTheme === "default_data_theme") {
      dispatch(setDataTheme("dark_data_theme"));
    } else {
      dispatch(setDataTheme("default_data_theme"));
    }
  };

  const toggleNotification = () => {
    setNotificationVisible(!notificationVisible);
  };

  const [isFullscreen, setIsFullscreen] = useState(false);
  const toggleFullscreen = () => {
    if (!isFullscreen) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen().catch((err) => {});
        setIsFullscreen(true);
      }
    } else {
      if (document.exitFullscreen) {
        if (document.fullscreenElement) {
          document.exitFullscreen().catch((err) => {});
        }
        setIsFullscreen(false);
      }
    }
  };

  const { academic_calendar } = useSelector((state: any) => state.auth);

  // Handle branch change
  const handleBranchChange = (branchId: string) => {
    const selected = school_locations.find(
      (branch: { id: string }) => branch.id === branchId
    );
    if (selected) {
      dispatch({
        type: SET_SELECTED_BRANCH,
        payload: selected,
      });
    }
  };

  return (
    <>
      {/* Header */}
      <div className="header">
        {/* Logo */}
        <div
          className="header-left active"
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          <Link to={routes.adminDashboard} className="logo logo-normal">
            <img
              src="../assets/img/startuplogo.png"
              style={{ width: "150px", height: "50px" }}
              alt="Logo"
            />
          </Link>
          <Link to={routes.adminDashboard} className="logo-small">
            <img src={school.badge_url} alt="Logo" />
          </Link>
          <Link to={routes.adminDashboard} className="dark-logo">
            <img src={school.badge_url} alt="Logo" />
          </Link>
          <Link id="toggle_btn" to="#" onClick={handleToggleMiniSidebar}>
            <i className="ti ti-menu-deep" />
          </Link>
        </div>
        {/* /Logo */}
        <Link
          id="mobile_btn"
          className="mobile_btn"
          to="#sidebar"
          onClick={toggleMobileSidebar}
        >
          <span className="bar-icon">
            <span />
            <span />
            <span />
          </span>
        </Link>
        <div className="header-user">
          <div className="nav user-menu">
            {/* School Name and Image */}
            {!isSuperAdminDashboard && !isSchoolSetup && !isSchoolList && (
              <div className="nav-item nav-search-inputs me-auto d-flex align-items-center justify-content-center w-20">
                <img
                  src={school.badge_url}
                  alt="School Logo"
                  style={{ width: "50px", height: "50px", marginRight: "10px" }}
                />
                <b
                  style={{
                    fontSize: "30px",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  {school.school_name}
                </b>
              </div>
            )}
            {/* /School Name and Image */}

            <div className="d-flex align-items-center">
              {/* Branch Selector */}
              {!isSuperAdminDashboard && !isSchoolSetup && !isSchoolList && (
                <div className="dropdown me-2">
                  {school_locations && school_locations.length > 1 ? (
                    <Select
                      style={{ width: 200 }}
                      value={
                        selected_branch && typeof selected_branch === "object" && "branch_name" in selected_branch
                          ? String((selected_branch as { branch_name: string }).branch_name)
                          : undefined
                      }
                      onChange={handleBranchChange}
                      options={school_locations.map(
                        (branch: { id: any; branch_name: any }) => ({
                          value: branch.id,
                          label: branch.branch_name, // Use branch_name instead of name
                        })
                      )}
                    />
                  ) : (
                    <Input
                      disabled
                      value={
                        selected_branch && "branch_name" in selected_branch
                          ? selected_branch.branch_name
                          : "No branch assigned"
                      }
                      style={{ width: 200 }}
                    />
                  )}
                </div>
              )}
              {/* /Branch Selector */}

              {/* Academic Year Dropdown */}
              {!isSuperAdminDashboard && !isSchoolSetup && !isSchoolList && (
                <div className="dropdown me-2">
                  <Link
                    to="#"
                    className="btn btn-outline-light fw-normal bg-white d-flex align-items-center p-2"
                  >
                    <i className="ti ti-calendar-due me-1" />
                    <b>
                      Academic Year:{" "}
                      {(academic_calendar &&
                        academic_calendar[0]?.academic_year) ||
                        ""}
                    </b>
                  </Link>
                </div>
              )}
              {/* /Academic Year Dropdown */}

              {/* Dark Mode Toggle */}
              <div className="pe-1">
                {!location.pathname.includes("layout-dark") && (
                  <Link
                    onClick={handleToggleClick}
                    to="#"
                    id="dark-mode-toggle"
                    className="dark-mode-toggle activate btn btn-outline-light bg-white btn-icon me-1"
                  >
                    <i
                      className={
                        dataTheme === "default_data_theme"
                          ? "ti ti-moon"
                          : "ti ti-brightness-up"
                      }
                    />
                  </Link>
                )}
              </div>
              {/* /Dark Mode Toggle */}

              {/* Fullscreen Toggle */}
              <div className="pe-1">
                <Link
                  onClick={toggleFullscreen}
                  to="#"
                  className="btn btn-outline-light bg-white btn-icon me-1"
                  id="btnFullscreen"
                >
                  <i className="ti ti-maximize" />
                </Link>
              </div>
              {/* /Fullscreen Toggle */}
            </div>

            {/* User Profile Dropdown */}
            <div className="dropdown ms-auto">
              <Link
                to="#"
                className="dropdown-toggle d-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <span className="avatar avatar-md rounded">
                  <img
                    src={
                      !isSuperAdminDashboard && !isSchoolList && !isSchoolSetup
                        ? school.badge_url
                        : "../assets/img/startupIcon.png"
                    }
                    alt="User"
                    className="img-fluid"
                  />
                </span>
              </Link>
              <div className="dropdown-menu dropdown-menu-end">
                <div className="d-block">
                  <div className="d-flex align-items-center p-2">
                    <span className="avatar avatar-md me-2 online avatar-rounded">
                      <img src={school.badge_url} alt="User" />
                    </span>
                    <div>
                      <h6>{user.name || user.full_name}</h6>
                      <p className="text-primary mb-0">{user.role}</p>
                    </div>
                  </div>
                  <hr className="m-0" />
                  <Link
                    className="dropdown-item d-inline-flex align-items-center p-2"
                    to={`${user.role}/profile`}
                  >
                    <i className="ti ti-user-circle me-2" />
                    My Profile
                  </Link>
                  <Link
                    className="dropdown-item d-inline-flex align-items-center p-2"
                    to={routes.profilesettings}
                  >
                    <i className="ti ti-settings me-2" />
                    Settings
                  </Link>
                  <hr className="m-0" />
                  <Link
                    className="dropdown-item d-inline-flex align-items-center p-2"
                    to={routes.login}
                  >
                    <i className="ti ti-login me-2" />
                    Logout
                  </Link>
                </div>
              </div>
            </div>
            {/* /User Profile Dropdown */}
          </div>
        </div>
        {/* Mobile Menu */}
        <div className="dropdown mobile-user-menu">
          <Link
            to="#"
            className="nav-link dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className="dropdown-menu dropdown-menu-end">
            <Link className="dropdown-item" to={`${user.role}/profile`}>
              My Profile
            </Link>
            <Link className="dropdown-item" to={routes.profilesettings}>
              Settings
            </Link>
            <Link className="dropdown-item" to={routes.login}>
              Logout
            </Link>
          </div>
        </div>
        {/* /Mobile Menu */}
      </div>
      {/* /Header */}
    </>
  );
};

export default Header;
